export default "__VITE_ASSET__e73a4b11__"